import {useTranslation} from 'react-i18next';
import {
  isCampaignTypeToolPartType,
  isParameterizationToolPartType,
  isWidgetToolPartType,
} from '../../../domain/campaignToolCatalog';
import {CAMPAIGN_WIDGET_TOOL_NAMES} from '../../../utils/campaignCompletionMessages';
import {
  isArtQueueToolPartType,
  isStrategyToolPartType,
} from '../../../domain/toolPartSelectors';
import {resolveToolErrorMessage} from '../../../utils/toolErrorMessages';
import styles from './styles.module.css';

export default function ToolPartRenderer({part}) {
  const {t} = useTranslation();

  if (!part || part.state !== 'output-available') {
    return null;
  }

  const {output} = part;

  if (output?.status === 'processing') {
    if (
      isStrategyToolPartType(part.type) ||
      isCampaignTypeToolPartType(part.type) ||
      isArtQueueToolPartType(part.type) ||
      part.type === `tool-${CAMPAIGN_WIDGET_TOOL_NAMES.EXECUTAR_AGENDAMENTO}`
    ) {
      return null;
    }
    return (
      <div className={styles.toolPartLoading}>
        {t('campaignChat.tool.processing', 'Processando...')}
      </div>
    );
  }

  if (output?.status === 'error') {
    return (
      <div className={styles.toolPartError}>
        {resolveToolErrorMessage(output.message, t)}
      </div>
    );
  }

  if (
    output?.status === 'awaiting_selection' ||
    (output?.status === 'completed' &&
      (isCampaignTypeToolPartType(part.type) ||
        isParameterizationToolPartType(part.type) ||
        isWidgetToolPartType(part.type)))
  ) {
    return null;
  }

  if (output?.status === 'completed') {
    if (isStrategyToolPartType(part.type)) {
      return null;
    }

    if (
      (part.type === 'tool-gerar_artes_campanha' ||
        part.type === 'tool-regerar_artes_campanha') &&
      Array.isArray(output.results)
    ) {
      return (
        <div className={styles.toolPartResult}>
          {t('campaignChat.tool.artsReady', '{{count}} artes geradas', {
            count: output.results.length,
          })}
        </div>
      );
    }

    return (
      <div className={styles.toolPartResult}>
        {t('campaignChat.tool.completed', 'Concluído.')}
      </div>
    );
  }

  return null;
}
